// extracted by mini-css-extract-plugin
export default {"logs":"UserLogs_logs__MjBV9"};